import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Form, Button, Input, Select } from 'antd';
import styled from 'styled-components'
import axios from 'axios';
import Cookies from 'js-cookie';
import ExpiredPasswordModal from './ExpiredPasswordModal';
import _ from 'lodash';
import ForgotPasswordModal from './ForgotPasswordModal';

const LoginForm = ({ssoType, clientId, tenantId, loginPath, Auth, Utility, $routeParams, $location, $ngRedux, $scope, setLoading, windowsAuth, showForgotPassword}) => {

	const clientSSO = $routeParams.ssoClientID;
	const isEdit = (typeof $routeParams.ssoServer !== 'undefined' && $routeParams.ssoServer !== '') && (typeof $routeParams.ssoRepo !== 'undefined' && $routeParams.ssoRepo != '');
	
	const [form] = Form.useForm();
	const { Option } = Select;
	
	localStorage.setItem('loginPage', $location.path());
	
	const loginTypes = [
		{
			key: "sql",
			displayName: "SQL User"
		},
		{
			key: "differentWindows",
			displayName: "Different Windows User"
		}
	];
	
	windowsAuth && loginTypes.splice(1, 0, {
		key: "currentWindows",
		displayName: "Current Windows User"
	})

	// only show Azure option if enabled in admin settings
	ssoType && loginTypes.push({
		key: "azure",
		displayName: "Microsoft Azure AD"
	})
	
	const [webLink] = useState(Utility.buildWebLink($routeParams));
	const [autoLogin, setAutoLogin] = useState(false);
	const [loginSettings, setLoginSettings] = useState({});
	const [loginError, setLoginError] = useState('');
	const [loginValues, setLoginValues] = useState({});
	const [expiredPassword, setExpiredPassword] = useState(false);
	const [resetPassword, setResetPassword] = useState(false);
	const [typeValue, setTypeValue] = useState('');

	const textboxStyle = {
		width: '100%'
	}

	const loginCallback = useCallback((authorized, redirect, message) => {
		if(authorized) {
			if(redirect) {
				$location.url(redirect);
			}
			else if($routeParams.redirect) {
				$location.url($routeParams.redirect);
			}
			else {
				window.sendToDefaultView($ngRedux, $location, Auth);
			}
		}
		else {
			if(message?.toLowerCase().indexOf('password is expired') > -1) {
				setExpiredPassword(true);
			}
			else {

				const err = autoLogin ? "Auto login failed.\nPlease contact your administrator for assistance." : message;

				setLoginError(err);
				setLoading(false);
			}
		}
	}, [$location, $ngRedux, $routeParams, Auth, autoLogin])

	const handleSubmit = useCallback(() => {

		if (typeValue === 'azure') { // HANDLE AZURE SSO
			if (ssoType === 'oidc') {
				axios.get(`api/app/validateServer?loginPath=${loginPath}&server=${loginValues.server}`).then(res => {
					if(!res.data.valid) {			
						if($routeParams.ssoClientID) {
							document.cookie = 'loginError=The provided server is not authorized.';
							$location.url(`/?ssoClientID=${$routeParams.ssoClientID}`);
							$scope.$apply();
						}
						else {
							const err = autoLogin ? 'Auto login failed.\nPlease contact your administrator for assistance.' : 'The provided server is not authorized.';

							setLoginError(err);
							setLoading(false);
						}
					} else {
						const msalConfig = {
							auth: {
								clientId: clientId,
								authority: `https://login.microsoftonline.com/${tenantId}/`,
								redirectUri: new window.URL($location.absUrl()).origin // get base URL
							},
							cache: {
								cacheLocation: "sessionStorage", // This configures where your cache will be stored
								storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
							}
						};
		
						const loginRequest = {
							scopes: ["User.Read"]
						};
		
						const myMSALObj = new msal.PublicClientApplication(msalConfig);
		
						myMSALObj.loginPopup(loginRequest).then((data) => {
		
							// handle thick client SSO
							if (clientSSO) {
		
								const clientId = $routeParams.ssoClientID;
		
								Auth.clientSSOLogin('oidc', clientId, loginValues.server, loginValues.repository, data.idToken, isEdit, (authorized, data) => {
									location.href = 'sso-complete.html'
								});
							}
							else {
								Auth.login(loginPath, 'oidc', '', '', '', loginValues.server, loginValues.repository, webLink, data.idToken, loginCallback);
							}
						}).catch(error => {
							console.error(error);
						});
					}
				})
			}
			else if (ssoType === 'saml') {

				if (clientSSO) {
					const clientId = $routeParams.ssoClientID;

					let redirectUrl = `/login-saml.aspx?clientId=${clientId}&repository=${loginValues.repository}&server=${loginValues.server}`

					if (isEdit) {
							redirectUrl += '&isEdit=1'
					}

					window.location.href = redirectUrl;
				}
				else {

					let redirectUrl = `/login-saml.aspx?loginPath=${loginPath || ''}
														&repository=${loginValues.repository || ''}
														&server=${loginValues.server || ''}
														&redirect=${encodeURIComponent($location.url())}`;

					window.location.href = redirectUrl;
				}
			}
		}
		else {
			Auth.login(
				loginPath,
				typeValue,
				loginValues.username,
				loginValues.password,
				loginValues.domain,
				loginValues.server,
				loginValues.repository,
				webLink,
				null,
				loginCallback
			);
		}
	}, [$location,
			$routeParams,
			$scope,
			Auth,
			clientSSO,
			isEdit,
			loginCallback,
			loginPath,
			loginValues,
			ssoType,
			tenantId,
			typeValue,
			webLink,
			clientId]);

	useEffect(() => {
		if(autoLogin === true && typeValue === 'azure') {

			const err = Cookies.get('azureAutoError');

			if(err) {
				setLoginError("Auto login failed.\nPlease contact your administrator for assistance.");
				setLoading(false);
				Cookies.remove('azureAutoError');
			}
			else {
				handleSubmit();
			}		

		}
	}, [autoLogin, handleSubmit, typeValue, setLoading])
	
	useEffect(() => {

		if(!clientSSO) {
			axios.post('/api/app/getLoginSettings/', {loginPath, webLink}).then((res) => {

				const dt = res.data.defaultType;

				if((!windowsAuth && dt === 'currentWindows') || (!ssoType && dt === "azure")) {
					setLoginError('This login page uses an authentication method that has not been configured.\n\nPlease contact your administrator for assistance.');
					setLoading(false);
					return;
				}
			
				setTypeValue(dt);

				if(res.data.auto === true) {
					setAutoLogin(true);
				}

				if(res.data.authorized) {
					if(res.data.redirect) {
						$location.url(res.data.redirect);
					}
					else {
						$location.url('/');
					}
				}
				else {
					if(_.isEmpty(res.data)) {
						$location.url('/login');
					}
					else {
						setLoginSettings(res.data);
						!res.data.auto && setLoading(false);
					}
	
					if(res.data.message) {
						setLoginError(res.data.message);
						setLoading(false);
					}
				}
	
				$scope.$apply();
			}).catch(error => {
				console.error(error);
				setLoading(false);
			})
		}
		else {
			setLoading(false);
			setTypeValue('azure');
			setLoginSettings(s => ({server: true, reposiotory: true}));

			if(isEdit) {
				setLoginValues({server: $routeParams.ssoServer, repository: $routeParams.ssoRepo})
			}
		}
	}, [$location,
			$routeParams,
			$scope,
			Utility,
			webLink,
			clientSSO,
			loginPath,
			setLoading,
			isEdit,
			windowsAuth,
			ssoType
		])

	useEffect(() => {
		if (Cookies.get('loginError')) {
			setLoginError(Cookies.get('loginError'));
			Cookies.remove('loginError');
		}
	}, [])
	
	const checkForm = () => {}

	const formItemLayout = {
    labelCol: {
      xs: { span: 6 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 18 },
      sm: { span: 18 },
    },
  };

	const formChanged = (changedFields) => {
			
		const newSettings = {
			...loginValues,
			...changedFields,
		}

		setLoginValues(newSettings);
	}

	const onClose = () => {
		setExpiredPassword(false);	
	}

	const onTypeChange = (value) => {
		setTypeValue(value);
		setLoginError('');
		form.setFields([
			{name: ['username'], errors: []},
			{name: ['password'], errors: []},
			{name: ['domain'], errors: []},
			{name: ['server'], errors: []},
			{name: ['repository'], errors: []},
		])
	}

	const onForgotPassword = () => {

		const { server, repository }  = form.getFieldsValue();

		if((!loginSettings.server || server ) && (!loginSettings.repository || repository)) {
			setResetPassword(true);
		}
		else {
			form.validateFields(['server', 'repository']);
		}
	}

	const onResetClose = () => {
		setResetPassword(false);
	}

  return(
		<LoginFormContainer>
			<ErrorMessage>{loginError}</ErrorMessage>
			{!_.isEmpty(loginSettings) &&
				<Form
					form={form}
					onFinish={values => handleSubmit(values)}
					onFieldsChange={checkForm}
					autoComplete="off"
					hideRequiredMark
					initialValues={loginValues}
					{...formItemLayout}
					onValuesChange={formChanged}
					style={{position: 'relative'}}
				>
					{loginSettings.types?.length > 1 &&
						<Form.Item label="Login Type" style={{ marginBottom: '8px' }}>
							<Select value={typeValue} onChange={onTypeChange}>
								{_.filter(loginTypes, o => _.includes(loginSettings.types, o.key)).map((type) => (
										<Option key={type.key} value={type.key}>{type.displayName}</Option>
									))
								}
							</Select>
						</Form.Item>
					}
					{loginSettings.username && (typeValue === 'sql' || typeValue === 'differentWindows') &&
						<Form.Item
							label="Username"
							name="username"
							style={{ marginBottom: '8px' }}
							rules={[{ required: true, whitespace: true, message: 'Username required' }]}
							>
							<Input style={textboxStyle} autoFocus />
						</Form.Item>
					}
					{(typeValue === 'sql' || typeValue === 'differentWindows') &&
						<Form.Item
							label="Password"
							name="password"
							style={{ marginBottom: '8px' }}
							rules={[{ required: true, whitespace: true, message: 'Password required' }]}
						>
							<Input style={textboxStyle} type="password" />
						</Form.Item>
					}
					{loginSettings.domain && typeValue === 'differentWindows' &&
						<Form.Item
							label="Domain"
							name="domain"
							style={{ marginBottom: '8px' }}
							rules={[{ required: true, whitespace: true, message: 'Domain required' }]}
						>
							<Input style={textboxStyle} />
						</Form.Item>
					}
					{(loginSettings.server || clientSSO) && 
						<Form.Item
							label="Server"
							name="server"
							style={{ marginBottom: '8px' }}
							rules={[{ required: true, whitespace: true, message: 'Server required' }]}
						>
							<Input style={textboxStyle}/>
						</Form.Item>
					}
					{(loginSettings.repository || clientSSO) &&
						<Form.Item
						label="Repository"
						name="repository"
						style={{ marginBottom: '8px' }}
						rules={[{ required: true, whitespace: true, message: 'Repository required' }]}
						>
							<Input style={textboxStyle}/>
						</Form.Item>
					}
					{!autoLogin &&
						<Form.Item
						shouldUpdate={true}
						style={{ margin: '15px 0 0 0' }}
						wrapperCol={{
							xs: { span: 12 },
							sm: { span: 12 },
							offset: 12
						}}
					>
						<Button
							type="primary"
							htmlType="submit"
							style={{ float: 'right', marginTop: '8px' }}
							offset={4}
						>
							Login
						</Button>
					</Form.Item>
					}
					{showForgotPassword && typeValue === 'sql' &&
						<ForgotPassword onClick={onForgotPassword}>
							Forgot Password
						</ForgotPassword>
					}
				</Form>
			}
		<ForgotPasswordModal visible={resetPassword} onClose={onResetClose} loginValues={loginValues} Auth={Auth} loginPath={loginPath} />
		<ExpiredPasswordModal visible={expiredPassword} Auth={Auth} loginPath={loginPath} loginValues={loginValues} onClose={onClose} loginCallback={loginCallback} />
	</LoginFormContainer>
  )
}

const LoginFormContainer = styled.div`
	width: 400px;
	margin: 10px auto;
	padding: 25px;
	border-radius: 2px;
	background-color: #fff;
	box-shadow: 0px 5px 5px -3px
							rgba(0,0,0,0.2), 0px 8px 10px 1px
							rgba(0,0,0,0.14), 0px 3px 14px 2px
							rgba(0,0,0,0.12);
`

const ForgotPassword = styled.div`
	position: absolute;
	bottom: 6px;
	left: 155px;
	color: #bbb;
	cursor: pointer;
	:hover {
		color: #888;
		text-decoration: underline;
	}
`

const ErrorMessage = styled.pre`
	margin-bottom: 20px;
	color: #d77534;
	text-align: center;
	font-family: inherit;
	overflow: hidden;
	white-space: pre-wrap;
`

const mapStateToProps = state => {
  const { ssoType, clientId, tenantId, windowsAuth, showForgotPassword } = state.app;
  return {
		ssoType,
		clientId,
		tenantId,
		windowsAuth,
		showForgotPassword
	};
};

export default connect(mapStateToProps)(LoginForm);
